import { useCallback, useEffect, useState } from "react";
import { fetchSelectionInfo } from "../utils/selectionApi";

// 解析选片短链的加载状态（独立于 delivery）。
// status: "loading" | "ready" | "invalid" | "expired" | "error"
export function useSelectionPayload(token) {
    const [state, setState] = useState({ status: "loading", payload: null });
    const [reloadKey, setReloadKey] = useState(0);

    const reload = useCallback(() => {
        setReloadKey((key) => key + 1);
    }, []);

    useEffect(() => {
        let cancelled = false;
        setState({ status: "loading", payload: null });
        fetchSelectionInfo(token)
            .then((payload) => {
                if (cancelled) {
                    return;
                }
                setState(
                    payload
                        ? { status: "ready", payload }
                        : { status: "invalid", payload: null }
                );
            })
            .catch((error) => {
                if (cancelled) {
                    return;
                }
                if (error?.code === "EXPIRED") {
                    setState({
                        status: "expired",
                        payload: { archiveMarkdown: error.archiveMarkdown || "" },
                    });
                } else {
                    setState({ status: "error", payload: null });
                }
            });
        return () => {
            cancelled = true;
        };
    }, [token, reloadKey]);

    return { ...state, reload };
}

export default useSelectionPayload;
